import React from 'react';
import drop from '../img/drop.png';
import user from '../img/user.png';
import { Link } from 'react-router-dom';

const Navbar = ({ logo }) => {   
    return (
        <nav className="navbar navbar-expand-sm navbar-dark px-sm-5 py-2">
            <Link className="navbar-brand" to="/">
                <img src={logo.url} width="120px" alt="SIHAH"/>
            </Link>
            <button className="btn border-0 mt-0 navbar-toggler" data-toggle="collapse" data-target="#nava">
                <img width="20px" src={drop} alt="Dropdown icon"/>
            </button>
            <div className="collapse navbar-collapse text-center" id="nava">
                <ul className="navbar-nav mt-3 mt-sm-0 ml-sm-auto flex-row align-items-center justify-content-center">
                    <li className="nav-item ml-4">
                        <Link className="nav-link" to="/order">
                            <button className="btn btn-one text-white">How To Order</button>
                        </Link>
                    </li>
                    <li className="nav-item ml-4">
                        <Link className="nav-link" to="/admin">
                                <img src={user} alt="Admin" width="30px" />
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;